const state = {
    studyIdForMultiupload: null,
    multiUploadFilesTotal: 0,
    multiUploadFilesUploaded: 0,
}

const mutations = {
    setStudyIdForMultiupload(state, value) {
        state.studyIdForMultiupload = value
        state.multiUploadFilesTotal = 0
        state.multiUploadFilesUploaded = 0
    },
    setMultiUploadFilesTotal(state, value) {
        state.multiUploadFilesTotal = value
    },
    incrementMultiUploadFilesUploaded(state) {
        state.multiUploadFilesUploaded++
    }
}

export default {
    state,
    mutations,
}
